import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import {
  IonContent,
  IonSkeletonText,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import parse from 'html-react-parser'
import { setRootMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import { getPlatformTerms } from '../../services/api/information'
import './styles.scss'

const TermsConditions = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [data, setData] = useState(false)
  const contentRef = useRef()
  const history = useHistory()

  useIonViewDidEnter(() => {
    setData(false)
    setIsVisible(true)
    setRootMetaTags()
    setView(window.location.pathname)
    setPixelView()
    getData()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  const getData = () => {
    getPlatformTerms({
      section: 'terms'
    }).then((response) => {
      setData(response)
    }).catch(() => {
      setData(false)
      history.push('/404')
    })
  }

  if (isVisible === false) return null

  return (
    <IonContent
      ref={contentRef}
      fullscreen
      className='terms-conditions-page page-wrapper'
    >
      <div className='flexible-width-content'>
        {!data &&
          <>
            <IonSkeletonText className='loading-title' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-title separated' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
            <IonSkeletonText className='loading-text' animated />
          </>}

        {data &&
          parse(data)}
      </div>
    </IonContent>
  )
}

export default TermsConditions
